@if (help.isOpen()) {
  <aside class="help-panel" role="complementary" aria-label="Help for this page">
    <header class="help-panel-head">
      <div>
        <span class="help-eyebrow">Help</span>
        <h2 class="help-title">{{ help.topic().title }}</h2>
      </div>
      <button nbButton ghost size="small" type="button" class="help-close" (click)="help.close()" aria-label="Close help" title="Close help">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </header>

    <div class="help-panel-body">
      @if (!help.isShowingTopic()) {
        <button type="button" class="help-back" (click)="help.showTopic()">&lsaquo; Back to {{ help.topic().title }}</button>
      }

      @switch (view().status) {
        @case ("loading") {
          <p class="help-status">Loading help&hellip;</p>
        }
        @case ("error") {
          <p class="help-status">
            This help could not be loaded.
            <a [href]="manualUrl()" target="_blank" rel="noopener">Open it in the user manual</a> instead.
          </p>
        }
        @case ("ready") {
          <ngx-help-article [page]="page()!" [section]="help.target().section" (navigate)="follow($event)"></ngx-help-article>
        }
      }

      @if (help.topic().related.length) {
        <nav class="help-related" aria-label="Related help">
          <h3>Related help</h3>
          <ul>
            @for (ref of help.topic().related; track ref.page + "#" + ref.section) {
              <li>
                <button type="button" class="help-link" [class.current]="isShowing(ref)" (click)="help.show(ref.page, ref.section)">{{ ref.label }}</button>
              </li>
            }
          </ul>
        </nav>
      }
    </div>

    <footer class="help-panel-foot">
      <a [href]="manualUrl()" target="_blank" rel="noopener">Open in the user manual</a>
      <a [href]="contentsUrl" target="_blank" rel="noopener">Manual contents and search</a>
    </footer>
  </aside>
}
